// Easter egg : taper « Ryan » ou « Axel » dans une barre de recherche → pluie d'or
(() => {
  const NOMS = /^(ryan|axel)$/;
  const propre = (t) => String(t || "").trim().toLowerCase();
  const doux = matchMedia("(prefers-reduced-motion: reduce)").matches;
  let enCours = false;

  function pluie(nom) {
    if (enCours) return;
    enCours = true;
    const c = document.createElement("canvas");
    c.className = "lx-or";
    c.setAttribute("aria-hidden", "true");
    document.body.appendChild(c);
    const ctx = c.getContext("2d");
    const dpr = Math.min(devicePixelRatio || 1, 2);
    let W, H;
    const taille = () => { W = innerWidth; H = innerHeight; c.width = W * dpr; c.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
    taille();
    addEventListener("resize", taille);

    // le prénom en grand, doré, au milieu
    const mot = document.createElement("div");
    mot.className = "lx-or-nom notranslate";
    mot.textContent = "✦ " + nom.charAt(0).toUpperCase() + nom.slice(1) + " ✦";
    document.body.appendChild(mot);

    const total = doux ? 60 : 260, duree = doux ? 2200 : 3600;
    const parts = [];
    const nouvelle = () => {
      const r = Math.random();
      parts.push({
        x: Math.random() * W, y: -30 - Math.random() * 60,
        vx: (Math.random() - 0.5) * 1.2, vy: 2 + Math.random() * 3.5,
        t: r < 0.45 ? "piece" : r < 0.85 ? "paillette" : "etoile",
        s: r < 0.45 ? 9 + Math.random() * 9 : r < 0.85 ? 3 + Math.random() * 5 : 6 + Math.random() * 6,
        a: Math.random() * Math.PI * 2, va: (Math.random() - 0.5) * 0.25,
        tour: Math.random() * Math.PI * 2, vtour: 0.08 + Math.random() * 0.12,
        balance: Math.random() * Math.PI * 2,
      });
    };

    const piece = (p) => {
      const sx = Math.cos(p.tour);                       // pièce qui tourne sur elle-même
      ctx.scale(Math.max(Math.abs(sx), 0.12), 1);
      const g = ctx.createRadialGradient(-p.s * 0.3, -p.s * 0.3, 1, 0, 0, p.s);
      g.addColorStop(0, "#FFF4C8"); g.addColorStop(0.45, sx > 0 ? "#F3D98B" : "#E3BE55"); g.addColorStop(1, "#B8863A");
      ctx.fillStyle = g;
      ctx.beginPath(); ctx.arc(0, 0, p.s, 0, Math.PI * 2); ctx.fill();
      ctx.strokeStyle = "rgba(122,84,24,.55)"; ctx.lineWidth = 1.2;
      ctx.beginPath(); ctx.arc(0, 0, p.s * 0.72, 0, Math.PI * 2); ctx.stroke();
    };
    const paillette = (p) => {
      ctx.fillStyle = Math.sin(p.tour) > 0 ? "#F3D98B" : "#D4AF37";
      ctx.fillRect(-p.s / 2, -p.s / 4 * Math.abs(Math.sin(p.tour)) - 1, p.s, p.s / 2 * Math.abs(Math.sin(p.tour)) + 2);
    };
    const etoile = (p) => {
      ctx.fillStyle = "#FFE9A8";
      ctx.shadowColor = "rgba(255,220,130,.9)"; ctx.shadowBlur = 10;
      ctx.beginPath();
      for (let i = 0; i < 8; i++) {
        const r = i % 2 ? p.s * 0.28 : p.s, an = (i * Math.PI) / 4;
        ctx.lineTo(Math.cos(an) * r, Math.sin(an) * r);
      }
      ctx.closePath(); ctx.fill();
    };

    const debut = performance.now();
    let creees = 0;
    function image(now) {
      const ecoule = now - debut;
      const voulues = Math.min(total, Math.floor((ecoule / (duree * 0.7)) * total));
      while (creees < voulues) { nouvelle(); creees++; }
      ctx.clearRect(0, 0, W, H);
      const fondu = ecoule > duree ? Math.max(0, 1 - (ecoule - duree) / 900) : 1;
      for (const p of parts) {
        p.balance += 0.04; p.vy = Math.min(p.vy + 0.06, 9);
        p.x += p.vx + Math.sin(p.balance) * 0.8; p.y += p.vy;
        p.a += p.va; p.tour += p.vtour;
        if (p.y > H + 40) continue;
        ctx.save();
        ctx.globalAlpha = fondu;
        ctx.translate(p.x, p.y); ctx.rotate(p.a);
        p.t === "piece" ? piece(p) : p.t === "paillette" ? paillette(p) : etoile(p);
        ctx.restore();
      }
      if (fondu > 0) requestAnimationFrame(image);
      else { c.remove(); mot.remove(); removeEventListener("resize", taille); enCours = false; }
    }
    requestAnimationFrame(image);
  }

  // à la frappe dans n'importe quelle barre de recherche (une fois par saisie du prénom)
  const dejaVu = new WeakMap();
  document.addEventListener("input", (e) => {
    const champ = e.target;
    if (!(champ instanceof HTMLInputElement) || !(champ.type === "search" || champ.name === "q")) return;
    const m = propre(champ.value).match(NOMS);
    if (m && dejaVu.get(champ) !== m[1]) { dejaVu.set(champ, m[1]); pluie(m[1]); }
    else if (!m) dejaVu.delete(champ);
  });

  // et en arrivant sur la page de résultats (/search?q=axel)
  const q = propre(new URLSearchParams(location.search).get("q")).match(NOMS);
  if (q && /\/search/.test(location.pathname)) {
    document.querySelectorAll('input[type="search"], input[name="q"]').forEach((ch) => dejaVu.set(ch, q[1]));
    setTimeout(() => pluie(q[1]), 400);
  }
})();
